// extracted by mini-css-extract-plugin
export default {"scanner":"ScanBarcode_scanner__s+3ip"};